// variants for growth_paywall_retrials experiment
export const VARIANT = 'variant'

// paywall name for one-button paywall
export const PAYWALL_TEXT_AS_IMAGES = 'paywall_text_as_images'
